{
  "fr": {
    "sharedLibrary": {
      "title": "Dépôt partagé",
      "subline": "Votre équipe met ici à disposition des modèles pour le quotidien scolaire – visibles uniquement pour votre école.\nCopiez ce dont vous avez besoin et ajoutez ce qui peut aider les autres.",
      "tutorial": "Voir le tutoriel",
      "paused": {
        "title": "Le dépôt partagé est en pause",
        "text": "La licence scolaire n'est plus active, mais les documents restent conservés.\nDès que la licence sera renouvelée, tu y auras à nouveau accès.",
        "activationLink": "Saisir un nouveau code d'activation",
        "modalTitle": "Saisir le code d'activation",
        "codeLabel": "Code d'activation de la licence scolaire",
        "codePlaceholder": "Saisir le code de la licence scolaire…",
        "success": "Licence scolaire activée ! Tu es désormais membre de « {groupTitle} »."
      },
      "createMenu": {
        "createNew": "Créer",
        "importFromMyContent": "Copier depuis Mon espace de stockage",
        "shareContent": "Partager du contenu"
      },
      "importDialog": {
        "title": "Copier depuis Mon espace de stockage",
        "tabLabel": "Mon espace de stockage",
        "searchPlaceholder": "Mot-clé…",
        "confirm": "Copier"
      },
      "search": {
        "placeholder": "Rechercher dans le dépôt partagé..."
      },
      "actions": {
        "copyToMyContent": "Copier dans Mon espace de stockage",
        "copyToMyContentPending": "Copie en cours dans Mon espace de stockage …",
        "copyToSharedLibrary": "Copier dans le dossier partagé"
      },
      "folderNotSupported": {
        "title": "Les dossiers ne peuvent pas encore être copiés dans le dépôt partagé",
        "selectionHint": "Sélectionnez le contenu du dossier et copiez-le individuellement ou ensemble."
      },
      "copyDialog": {
        "title": "Copier dans le stockage partagé",
        "school": "École",
        "folder": "Dossier",
        "createFolder": "Créer un nouveau dossier",
        "newFolderName": "Nom du nouveau dossier",
        "folderLoadError": "Les dossiers n'ont pas pu être chargés. Veuillez réessayer."
      },
      "moveDialog": {
        "mixedSelection": "Les contenus sélectionnés se trouvent dans différents emplacements. Le déplacement n'est possible qu'au sein d'un même emplacement – sélectionnez des contenus provenant d'un seul emplacement."
      },
      "copyResult": {
        "success": "Le contenu a été copié avec succès dans le stockage partagé",
        "failure": "Votre sélection n'a pas pu être copiée dans le stockage partagé",
        "retry": "Veuillez réessayer.",
        "responsesNotCopied": "Les contributions de vos élèves ne sont pas copiées"
      },
      "adoptDialog": {
        "title": "Copier dans Mon espace de stockage",
        "folder": "Dossier"
      },
      "adoptResult": {
        "success": "Le contenu a été copié avec succès dans Mon espace de stockage",
        "failure": "Votre sélection n'a pas pu être copiée dans Mon espace de stockage"
      },
      "schoolSelect": {
        "ariaLabel": "Changer d'école",
        "hint": "Ici, tu peux sélectionner ton école"
      },
      "links": {
        "backToLibrary": "Accéder au dépôt partagé",
        "trash": "Voir la corbeille"
      },
      "emptyState": {
        "root": "Il n'y a encore aucun contenu dans le dépôt commun de votre école.",
        "folder": "Il n'y a actuellement aucun contenu dans ce dossier."
      },
      "noAccess": {
        "noSchool": {
          "title": "Vous n'appartenez encore à aucune école",
          "text": "Le dépôt commun est toujours rattaché à une école. Dès que vous serez rattaché·e à une école, vous trouverez ici les documents de votre équipe pédagogique."
        },
        "disabledBySchool": {
          "title": "Votre école a désactivé le dépôt commun",
          "text": "Le dépôt commun est désactivé pour votre école. Contactez la gestion des licences de votre école si vous souhaitez le réactiver."
        },
        "refusedBySchool": {
          "title": "Ce dossier partagé ne vous est plus accessible",
          "text": "Votre école ne vous donne actuellement pas accès à ce dossier partagé. Cela se produit lorsque votre adhésion a pris fin ou que votre école a désactivé le dossier partagé. Rechargez la page ou contactez la gestion des licences de votre école."
        }
      },
      "copySelectionDialog": {
        "title": "Copier la sélection dans le dépôt partagé",
        "school": "École",
        "createFolder": "Créer un nouveau dossier",
        "newFolderName": "Nom du nouveau dossier"
      },
      "trash": {
        "heading": "Corbeille",
        "buttons": {
          "clear": "Vider la corbeille"
        },
        "emptyTable": "Il n'y a actuellement aucun contenu supprimé dans le dépôt commun de votre école.",
        "subline": "Les matériels et dossiers supprimés restent <strong>30 jours</strong> dans la corbeille. Jusqu'à cette date, ils peuvent être restaurés, après quoi ils sont définitivement supprimés."
      },
      "preview": {
        "loadError": "Le contenu n'a pas pu être chargé.",
        "noTask": "Aucune tâche de travail n'est définie.",
        "noWords": "Aucun mot n'a encore été saisi.",
        "qrCodeAlt": "QR code pour {url}",
        "targetUrl": "URL cible",
        "type": "Type"
      },
      "editorGuard": {
        "noPreview": "Ce matériel ne peut être modifié que par la personne qui l'a créé."
      }
    }
  }
}
